export const inspectionLinkAdapter = inspectionResponse => {
  if (!inspectionResponse) {
    return null
  }

  return inspectionResponse.url || ''
}
